import React from 'react';
import './app.css';
import ColorPicker from './ColorPicker';
import Player from './PlayerComponent';
import SnippetComponent from './SnippetComponent';

class AppComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      colorPickerState: [],
      snippet: "Hello world!",
      hidden: 'group'
    };
  }


  colorPickerChildCallback(data) {
    const key = data.id;
    const state = this.state.colorPickerState;

    state[key] = data;
    this.setState({ colorPickerState: state });
    console.log('colorPickerChildCallback', data.individual)
    this.setState({ hidden: data.individual });
  }

  render() {
    return (
      <div>
          <section className="row">
            <aside className="col-sm-12 col-md-4 col-lg-4">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <h5 className="mb-2 card-title">Designer Options</h5>
                  <span>
                    Feel free to choose one of the options displayed below, AMP will support one at the time please make sure the configuration selected adapts to your needs.
                    </span>
                </div>
              </div>
              <hr className="py-1"></hr>
              <div className="shadow p-3 mb-5 bg-white rounded card-body">

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <h5 className="card-title ak-text-pink">API Theme options <span className="badge badge-pill badge-danger">New</span></h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Text Color</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="group" className="" id="text" property="color" selector="amp-ui" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden} ></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Background Color</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="group" className="" id="background" property="background-color" selector="amp-bg" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Foreground Color</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="group" className="" id="foreground" property="color" selector="amp-icon" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
              </div>
              <hr className="py-1"></hr>
              <div className="shadow p-3 mb-5 bg-white rounded card-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <h5 className="card-title ak-text-pink">CSS Theme options</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Control bar</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-controls" property="background-color" selector="amp-controls, .amp-preview" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden} ></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Play/Pause Overlay</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-play-overlay" property="background-color" selector="amp-pause-overlay" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Icons</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-icon" property="color" selector="amp-icon" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Volume Slider</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-slider" property="background-color" selector="amp-volume .amp-value" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Progress Bar</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-slider" property="background-color" selector="amp-progress .amp-value, .amp-track" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-9 col-md-8 col-lg-9">
                    <label className="text-muted">Text Color</label>
                  </div>
                  <div className="col-4 col-sm-3 col-md-4 col-lg-3">
                    <ColorPicker type="individual" className="" id="color-font" property="color" selector="amp-time-display, .amp-panel" getInput={this.colorPickerChildCallback.bind(this)} data={this.state.hidden}></ColorPicker>
                  </div>
                </div>
              </div>

            </aside>
            <aside className="py-1 col-sm-12 col-md-8 col-lg-8">
              <Player data={this.state.colorPickerState} hidden={this.state.hidden} />
              <SnippetComponent data={this.state.colorPickerState} hidden={this.state.hidden} />
            </aside>
          </section>
      </div >
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;


